import * as stylex from "@stylexjs/stylex";
import { FormattedMessage } from "react-intl";
import { colors } from "../materials/consts.stylex";
export const SkipNavigation = ({ id })=>{
    return <a href={`#${id}`} data-skip-search className="xj8z8mm xjm9jq1 x1i1rx1s xb3r6kr x1qvwoe0 xuxw1ft x1nwz2bd x162sep x11ud8k4 xrta9n2 xfnbp2s xf6pxvo x1ftzldt x14jblac x1kfqjn2 x1gqlb9g">
      <FormattedMessage id="Skip to main content" defaultMessage="Skip to main content"/>
    </a>;
};
